export default __webpack_public_path__ + "static/silverLCover-80ac46700529884af3540ab8634893eb.png";